<script>
// Helper function to pad single-digit numbers with a leading zero
export default {
    filters: {
        formatDate(date, locale = null) {
            return new Date(date).toLocaleDateString(locale ? locale : navigator.language);
        },
        formatDateTime(date, locale = null) {
            date = new Date(date);
            let formattedDate = new Intl.DateTimeFormat(locale ? locale : navigator.language, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            }).format(date);

            return formattedDate;
        },
        formatTime(date, locale = null) {
            date = new Date(date);
            return date.toLocaleTimeString(locale ? locale : navigator.language);
        },
    },
};
</script>
